if (!customElements.get('delivery-threshold')) {
  customElements.define(
    'delivery-threshold',
    class DeliveryThreshold extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-delivery-text]');
        this.showBelow = this.dataset.showBelow === 'true';

        try {
          this.variants = JSON.parse(this.dataset.variants || '{}');
        } catch (e) {
          // A malformed map must not take the buy box down with it — the
          // server-rendered message for the current variant stays as-is.
          this.variants = {};
        }

        // Single-variant products never fire variantChange, and the server-rendered
        // message is already correct for them — so a missing pub/sub is survivable.
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.update(event.data.variant);
        });
      }

      disconnectedCallback() {
        if (this.unsubscriber) this.unsubscriber();
      }

      update(variant) {
        const state = variant ? this.variants[variant.id] : null;

        if (!state) {
          this.hidden = true;
          return;
        }

        if (state.q) {
          this.textEl.textContent = this.dataset.msgQualifies;
          this.classList.add('product__delivery-threshold--qualified');
          this.hidden = false;
        } else if (this.showBelow) {
          this.textEl.textContent = this.dataset.msgBelow.replace('[amount]', state.m);
          this.classList.remove('product__delivery-threshold--qualified');
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }
  );
}
